import { AdminSection } from "./adminSections";
import { AdminVehicleOverride } from "./adminStore";
import { listImageOverrides } from "../../lib/imageStore";

export interface ImageRegistryEntry {
  resourceKey: string;
  projectPath: string;
  selectedFileName: string;
  fileType: string;
  fileSize: number;
  selectedAt: string;
  hasLocalPreview: true;
}

// Single source of truth for "which real project file does this image
// resourceKey correspond to" — used both for the human-readable image
// registry export AND to tell the backend exactly where to write each
// image when saving to the project, so the two never drift apart.
export function buildImagePathMap(
  sections: AdminSection[],
  vehicles: AdminVehicleOverride[],
): Record<string, string> {
  const pathByKey: Record<string, string> = {};

  sections.forEach((section) => {
    (section.images || []).forEach((img) => {
      pathByKey[img.key] = img.path;
    });
  });

  vehicles.forEach((vehicle) => {
    pathByKey[`vehicle.${vehicle.id}`] = vehicle.imagePath;
  });

  return pathByKey;
}

// Builds the lightweight metadata registry (no base64 payloads) describing
// which local image previews are currently active and which project file
// each one should replace.
export function buildImageRegistry(
  sections: AdminSection[],
  vehicles: AdminVehicleOverride[],
): ImageRegistryEntry[] {
  const overrides = listImageOverrides();
  const pathByKey = buildImagePathMap(sections, vehicles);

  return Object.entries(overrides).map(([resourceKey, meta]) => ({
    resourceKey,
    projectPath: pathByKey[resourceKey] || "Ruta no identificada",
    selectedFileName: meta.fileName,
    fileType: meta.fileType,
    fileSize: meta.fileSize,
    selectedAt: meta.selectedAt,
    hasLocalPreview: true as const,
  }));
}

